<div class="card w-100 h-100 bg-light border-0 shadow" >
  <div class="d-flex align-items-center justify-content-center p-4">
    <img class="card-img-top round-img" [src]="'assets/images/products/' +product.image" [alt]="product.image">
  </div>
  <div class="card-body product-info bg-white">
    <h5 class="card-title text-center">{{product.name}}</h5>
    <label *ngIf="product.description">{{product.description}}</label>
    <label *ngIf="product.sizes"><strong>Sizes: </strong>{{product.sizes}}</label>
    <label *ngIf="product.schedule"><strong>Schedule: </strong>{{product.schedule}}</label>
    <label *ngIf="product.classes"><strong>Class: </strong>{{buildString(product.classes)}}</label>
    <label *ngIf="product.types"><strong>Type: </strong>{{buildString(product.types)}}</label>
    <label *ngIf="product.standards"><strong>Standards: </strong>{{buildString(product.standards)}}</label>
    <label *ngIf="product.others"><strong>Others: </strong>{{product.others}}</label>
  </div>
</div>
